import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_PaymentStatus, BASEURL_POLYMER } from '../../utils/api'
import { PaymentStatus } from '../../models/polymer/PaymentStatus.model'
interface QueryParams {
  application_uuid: string
  singpass_token: string

}
export const getPaymentStatusApi = createApi({
  reducerPath: 'getPaymentStatusApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER,
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "GET");
    headers.set("X-Content-Type-Options", "nosniff");
  }}),
  endpoints: (builder) => ({
    getPaymentStatusApi: builder.query<PaymentStatus, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url:`${API_PaymentStatus}?applicationUuid=${queryParams.application_uuid}`,
        headers: {
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      transformResponse:(response: PaymentStatus, meta, arg)=>{
        console.log('DEBUG: Raw API response for PaymentStatusAPI:', response);
        return response;
      }
    }),
    
   
  }),
})
 
export const { useGetPaymentStatusApiQuery } = getPaymentStatusApi

